import { type MCPServerInfo } from '../../types';

const FirecrawlServer: MCPServerInfo = {
  serverId: 'FIRECRAWL',
  name: 'Firecrawl',
  slug: 'firecrawl',
  description:
    'Official Firecrawl MCP Server - Adds powerful web scraping and search to Cursor, Claude and any other LLM clients.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/firecrawl:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['firecrawlApiKey'],
    properties: {
      firecrawlApiKey: {
        type: 'string',
        description: 'Firecrawl API Key',
        sensitive: true
      },
      firecrawlApiUrl: {
        type: 'string',
        description: 'Custom Firecrawl API URL for self-hosted instances',
        sensitive: false
      }
    }
  }
};

export default FirecrawlServer;
